function getTitleBase() {
  let result;
  switch (process.env.GATSBY_SITE) {
    case "vorne.com": {
      result = "Vorne";
      break;
    }
    case "oee.com": {
      result = "OEE";
      break;
    }
    case "leanproduction.com": {
      result = "Lean Production";
      break;
    }
  }
  return result;
}

export { getTitleBase };
